<template>
  <div>
    <div style="width: 95%">
      <b-card bg-variant="light">
        <b-form-group
            label-cols-lg="3"
            label="Group Members"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0"
        />
        <b-container container-fluid>
          <b-form-group label="Membership Invitations:" v-slot="{ ariaDescribedby }">
            <!--              <div class="mt-4 table">-->
            <b-table sticky-header :fields="invitationCols" :items="items" show-empty>
              <template #empty="scope">
                This user currently has no groups assigned.
              </template>
              <!-- A custom formatted data column cell -->
              <template #cell(createdAt)="data">
                {{ new Date(data.value).toLocaleDateString() }}
              </template>
              <template #cell(name)="data">
                {{ data.value }}
              </template>
              <template #cell(requestSent)="{ item, field: { key } }">
                <b-form-checkbox
                    v-model="item[key]"
                    value="true"
                    unchecked-value="false"
                    :disabled=true
                />
              </template>
              <template #cell(requestAccepted)="{ item, field: { key } }">
                <b-form-checkbox
                    v-model="item[key]"
                    value="true"
                    unchecked-value="false"
                    :disabled=true
                />
              </template>

              <!-- A custom formatted header cell for field 'name' -->
              <template #head(name)="data">
                <span class="text-info">{{ data.label }}</span>
              </template>

              <!-- A custom formatted footer cell for field 'name' -->
              <template #foot(name)="data">
                <span class="text-danger">{{ data.value }}</span>
              </template>

              <!-- Default fall-back custom formatted footer cell -->
              <template #foot()="data">
                <i>{{ data.name }}</i>
              </template>
            </b-table>
            <!--              </div>-->
          </b-form-group>
        </b-container>
        <b-row>
          <b-col cols="5">
          </b-col>
          <b-col cols="3">
            <b-button v-if="canSendInvite" v-b-modal.modal-1>Add Group Member</b-button>
          </b-col>
          <b-col cols="4">
          </b-col>
        </b-row>

        <b-modal size="lg" id="modal-1" centered title="Invite Team Member" effect="fade/zoom" hide-footer>
          <b-container container-fluid style="width:100%;">
            <p class="my-4">Enter The Person You Would Like To Invite.</p>
            <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Name"
                          label-for="input-sm">
              <b-form-input class="w-75" id="input-md" size="md" v-model="request.invitee"/>
            </b-form-group>
            <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email"
                          label-for="input-sm" :invalid-feedback="invalidFeedback">
              <b-form-input class="w-75" id="input-md" size="md" v-model="request.inviteEmail"/>
              <div style="color: red; font-size: 10pt" :v-if="invalidEmail">Valid Email Required*</div>
            </b-form-group>
            <b-form-group label="Selected Groups:" v-slot="{ ariaDescribedby }">
              <!--              <div class="mt-4 table">-->
              <b-table sticky-header :fields="selectedGroupCols" :items="selectedGroups" show-empty>
                <template #empty="scope">
                  This user currently has no groups assigned.
                </template>
                <!-- A custom formatted data column cell -->
                <template #cell(id)="data">
                  {{ data.value }}
                </template>
                <template #cell(name)="data">
                  {{ data.value }}
                </template>
                <template #cell(selected)="{ item, field: { key } }">
                  <b-form-checkbox
                      v-model="item[key]"
                      value="true"
                      unchecked-value="false"
                      :disabled=true
                  />
                </template>
                <template #cell(groupAdminRole)="{ item, field: { key } }">
                  <b-form-checkbox
                      v-model="item[key]"
                      value="true"
                      unchecked-value="false"
                      :disabled=true
                  />
                </template>

                <!-- A custom formatted header cell for field 'name' -->
                <template #head(name)="data">
                  <span class="text-info">{{ data.label }}</span>
                </template>

                <!-- A custom formatted footer cell for field 'name' -->
                <template #foot(name)="data">
                  <span class="text-danger">{{ data.value }}</span>
                </template>

                <!-- Default fall-back custom formatted footer cell -->
                <template #foot()="data">
                  <i>{{ data.name }}</i>
                </template>
              </b-table>
              <!--              </div>-->
            </b-form-group>
            <b-form-group label="Groups:" v-slot="{ ariaDescribedby }">
              <!--              <div class="mt-5 table">-->
              <b-table sticky-header :fields="groupCols" :items="filtered">
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <input v-if="field.key === 'name' || field.key === 'id'" v-model="filters[field.key]"
                           :placeholder="field.label">
                  </td>
                </template>
                <!-- A custom formatted data column cell -->
                <template #cell(id)="data">
                  {{ data.value }}
                </template>
                <template #cell(name)="data">
                  {{ data.value }}
                </template>
                <template #cell(selected)="{ item, field: { key } }">
                  <b-form-checkbox
                      v-model="item[key]"
                      value="true"
                      unchecked-value="false"
                      @change="updateSelectedGroups(item)"
                  />
                </template>
                <template #cell(groupAdminRole)="{ item, field: { key } }">
                  <b-form-checkbox
                      v-model="item[key]"
                      value="true"
                      unchecked-value="false"
                      @change="updateIsGroupAdmin(item)"
                  />
                </template>

                <!-- A custom formatted header cell for field 'name' -->
                <template #head(name)="data">
                  <span class="text-info">{{ data.label }}</span>
                </template>

                <!-- A custom formatted footer cell for field 'name' -->
                <template #foot(name)="data">
                  <span class="text-danger">{{ data.value }}</span>
                </template>

                <!-- Default fall-back custom formatted footer cell -->
                <template #foot()="data">
                  <i>{{ data.name }}</i>
                </template>
              </b-table>
              <!--              </div>-->
            </b-form-group>
            <div slot="modal-footer" class="modal-footer">
              <button type="submit" class="btn btn-success" @click="saveAction">Invite</button>
              <button type="button" class="btn btn-default" @click="dismissTheModal">Cancel</button>
            </div>
          </b-container>
        </b-modal>
      </b-card>
    </div>
  </div>

</template>

<script>
//import VueInputUi from 'vue-input-ui';

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "GroupAdmin",
  components: {
    //  VueInputUi
  },
  data() {
    return {
      items: [],
      darkMode: false,
      request: {},
      invalidEmail: false,
      groups: [],
      invitationCols: [{key: 'createdAt', label: 'Created Date'},
        {key: 'inviteEmail', label: 'Invitee Email'},
        {key: 'invitee', label: 'Invitee'},
        {key: 'requestAccepted', label: 'Request Accepted'},
        {key: 'requestSent', label: 'Request Sent'}],
      groupCols: [
        {key: 'selected', label: 'Add'},
        {key: 'name', label: 'Name'},
        {key: 'groupAdminRole', label: 'Group Admin'}
      ],
      selectedGroupCols: [
        {key: 'selected', label: 'Selected'},
        {key: 'name', label: 'Name'},
        {key: 'groupAdminRole', label: 'Group Admin'}
      ],
      groupsList: [{name: 'My Group', id: '1325645'}, {name: 'Your Group', id: '1325645'}, {
        name: 'Arvidus Group',
        id: '1325647'
      }],
      filters: {
        selected: '',
        id: '',
        name: '',
        groupAdminRole: ''
      },
      selectedGroups: []
    }
  },
  mounted() {
    this.loadGroupMembers();
    this.loadAccessibleGroups();
  },
  computed: {
    filtered() {
      const filtered = this.groupsList.filter(item => {
        return Object.keys(this.filters).every(key =>
            String(item[key]).includes(this.filters[key]))
      })
      return filtered.length > 0 ? filtered : [{
        selected: '',
        id: '',
        name: '',
        groupAdminRole: ''
      }]
    },
    canSendInvite() {
      let groupRoles = localStorage.getObject('groupRoles');
      return groupRoles.filter(groupRole => groupRole.groupId === localStorage.getItem('groupId'))
          .map(groupRole => groupRole.role)
          .some(v => ["GROUP_ADMIN", "admin"].includes(v));
    }
  },
  methods:
      {
        updateSelectedGroups(rowItem) {
          let isSelected = !rowItem['selected'];
          let itemId = rowItem["id"];
          let groupsToAdd = this.groupsList.filter(val => val.id === itemId);
          console.log(`Row Id ${itemId}`);
          if (isSelected) {
            this.selectedGroups.push(...groupsToAdd);
          } else {
            this.selectedGroups = this.selectedGroups.filter(group => {
              return group.id !== itemId;
            })
          }
        },
        updateIsGroupAdmin(rowItem) {
          let itemId = rowItem["id"];
          let groupToUpdate = rowItem;
          this.selectedGroups.filter(group => {
            return group.id === itemId;
          })
              .forEach(group => {
                let groupAdminRole = !(groupToUpdate.groupAdminRole === 'true' || groupToUpdate.groupAdminRole === true);
                let index1 = this.selectedGroups.findIndex((element, index, array) => {
                  if (element.id === groupToUpdate.id) {
                    return true;
                  }
                })
                group.groupAdminRole = groupAdminRole;
                this.$set(this.selectedGroups, index1, group);
              })
        },
        validateEmail: function (mail) {
          if (emailRegex.test(mail)) {
            this.invalidEmail = false;
            return (true)
          }
          this.invalidEmail = true;
          return (false)
        },
        invalidFeedback: function () {
          if (this.validateEmail(this.request.inviteEmail)) {
            return '';
          } else {
            return 'Please enter a valid email.'
          }
        },
        loadGroupMembers: function () {
          console.log("Mounting The GroupAdmin");
          this.$http.get("account/invite/" + localStorage.getItem('groupId'))
              .then(result => {
                this.items = result.data;
              }).catch(err => {
            console.log(err)
          });
        },
        loadAccessibleGroups: function () {
          console.log("Getting list of groups can add to");
          this.$http.get(`account/user/${localStorage.getItem('user')}/group-admin`)
              .then(result => {
                let adminGroups = [];
                Object.entries(result.data).forEach(group => {
                  adminGroups.push({selected: false, id: group[0], name: group[1], groupAdminRole: false})
                });
                this.groupsList = adminGroups;
              }).catch(err => {
            console.log(err)
          });
        },
        saveAction: function () {
          if (this.validateEmail(this.request.inviteEmail)) {
            this.$bvModal.hide("modal-1");
            swal({
              title: "Group Member Invitation Submitted",
              type: "success",
              timer: 3000
            });
            this.request.groupId = localStorage.getItem('groupId');
            this.request.groupsToAdd = Object.fromEntries(new Map(this.groupsList.filter(grp => {
              return grp.selected;
            })
                .map(i => [i.id, i.groupAdminRole])));
            let inviteRequest = JSON.stringify(this.request, null, 3);
            this.$http.post("account/invite", inviteRequest, {
              headers: {
                'content-type': 'application/json'
              }
            })
                .then(response => {
                  console.log(response);
                  this.loadGroupMembers();
                })
                .catch(fail => {
                  swal("Invitation Failed.");
                  console.log(fail);
                });
          }
        },
        dismissTheModal: function () {
          this.$bvModal.hide("modal-1");
        }
      }
}
</script>

<style scoped>
.table {
  height: 30vh;
  overflow-y: scroll;
}

</style>
